import { combineReducers } from "redux"
import LoadingReducer from "./LoadingReducer";
import ResourcesReducer from "./ResourcesReducer";
import ProjectReducer from "./ProjectReducer";
import TenderReducer from "./TenderReducer";
import PaginationReducer from "./PaginationReducer";
import jobMaster from "./job-master/job-master-reducer";

const rootReducer = combineReducers({
    LoadingReducer: LoadingReducer,
    ResourcesReducer: ResourcesReducer,
    ProjectReducer: ProjectReducer,
    TenderReducer: TenderReducer,
    PaginationReducer: PaginationReducer,
    jobMaster: jobMaster
})

export default rootReducer;